export default __webpack_public_path__ + "static/media/bridge-logo.3309207f.png";